import { createAction } from '@reduxjs/toolkit';
import { genericSETypes } from 'redux-utils/types/index';
import reducerModel from 'models/reducerModel';

const getChartData = (
  payload,
  meta = { reducerID: [reducerModel.genericSE.id] }
) => {
  const action = createAction(genericSETypes.getChartData.request)({
    ...payload
  });
  action.meta = meta;
  return action;
};

const getChartList = (
  payload,
  meta = { reducerID: [reducerModel.genericSE.id] }
) => {
  const action = createAction(genericSETypes.getChartList.request)({
    ...payload
  });
  action.meta = meta;
  return action;
};

const getBottomUpFilter = (
  payload,
  meta = { reducerID: [reducerModel.genericSE.id] }
) => {
  const action = createAction(genericSETypes.getBottomUpFilter.request)({
    ...payload
  });
  action.meta = meta;
  return action;
};

const getCurrentFilter = (
  payload,
  meta = { reducerID: [reducerModel.genericSE.id] }
) => {
  const action = createAction(genericSETypes.getFilter.request)({
    ...payload
  });
  action.meta = meta;
  return action;
};

const bumpFilterEpoch = (
  payload,
  meta = { reducerID: [reducerModel.genericSE.id] }
) => {
  const action = createAction(genericSETypes.bumpFilterEpoch)({
    ...payload
  });
  action.meta = meta;
  return action;
};

const getFilters = (
  payload,
  meta = { reducerID: [reducerModel.genericSE.id] }
) => {
  const action = createAction(genericSETypes.getFilters.request)({
    ...payload
  });
  action.meta = meta;
  return action;
};

const downloadChartData = (
  payload,
  meta = { reducerID: [reducerModel.genericSE.id] }
) => {
  const action = createAction(genericSETypes.downloadChartData.request)({
    ...payload
  });
  action.meta = meta;
  return action;
};

const filterChangeAction = (
  payload,
  meta = {
    reducerID: [reducerModel.genericSE.id]
  }
) => {
  const action = createAction(genericSETypes.genericSEfilterChange)({
    ...payload
  });
  action.meta = meta;
  return action;
};

const getSessionFilterValues = (
  payload,
  meta = {
    reducerID: [reducerModel.genericSE.id]
  }
) => {
  const action = createAction(genericSETypes.sessionFilterValues.request)({
    ...payload
  });
  action.meta = meta;
  return action;
};

const clearChartList = (
  payload,
  meta = {
    reducerID: [reducerModel.genericSE.id]
  }
) => {
  const action = createAction(genericSETypes.getChartList.clear)({
    ...payload
  });
  action.meta = meta;
  return action;
};

// the split session-data legs. fetchSplitSessionData is the single entry point:
// it records the filters once (mirroring the setSessionFilters side effect the
// monolith performs on success) and fans out to all three legs in parallel.
const makeSplitLegAction = actionGroup => (
  payload,
  meta = { reducerID: [reducerModel.genericSE.id] }
) => {
  const action = createAction(actionGroup.request)({ ...payload });
  action.meta = meta;
  return action;
};

const getSessionDataImages = makeSplitLegAction(
  genericSETypes.getSessionDataImages
);
const getSessionDataMisc = makeSplitLegAction(
  genericSETypes.getSessionDataMisc
);
const getSessionDataVariants = makeSplitLegAction(
  genericSETypes.getSessionDataVariants
);

const setSessionFilters = (
  payload,
  meta = { reducerID: [reducerModel.genericSE.id] }
) => {
  const action = createAction(genericSETypes.setSessionFilters)({ ...payload });
  action.meta = meta;
  return action;
};

const clearSplitSessionData = (
  payload,
  meta = { reducerID: [reducerModel.genericSE.id] }
) => {
  const action = createAction(genericSETypes.splitSessionDataClear)({
    ...payload
  });
  action.meta = meta;
  return action;
};

export {
  getFilters,
  getChartData,
  getChartList,
  getSessionDataImages,
  getSessionDataMisc,
  getSessionDataVariants,
  clearSplitSessionData,
  setSessionFilters,
  getCurrentFilter,
  downloadChartData,
  filterChangeAction,
  getSessionFilterValues,
  clearChartList,
  getBottomUpFilter,
  bumpFilterEpoch
};
